import { Component, OnInit } from '@angular/core';
import { ActivatedRoute,Params, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { FilterModel } from 'src/Models/filterModel';
import { BriefingModel } from 'src/Models/TrfaAlertsModel';
import { TrfaAlertService } from 'src/Services/alert.service';
import { CheckAuth } from 'src/Services/utility.service';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-user-briefing-alerts',
  templateUrl: './user-briefing-alerts.component.html',
  styleUrls: ['./user-briefing-alerts.component.css']
})
export class UserBriefingAlertsComponent implements OnInit {

  tokenKey: string = '';
  isloading: boolean = false;
  filterModel = new FilterModel();
  BriefingModel1: BriefingModel[]=[];
  totalRecordCount1: number = -1;
  briefingId:number;
  userId:number = 0;
  keywordFilter: string=" ";
  pageNumber:number;
  pageSize:number;
  title: string = '';
  orderBy:string;
  upDownEmailCSS: string = '';
  upDownNameCSS: string = '';
  isAscending: boolean;

  constructor(private readonly activedRoute: ActivatedRoute,
    private readonly toastr: ToastrService, 
    private readonly router: Router, 
    private readonly checkAuth: CheckAuth,
    private readonly trfaAlertServices:TrfaAlertService,
    private sessionStorageService: SessionStorageService
  ) { 
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  ngOnInit() {
    this.BriefingModel1=[];
    this.keywordFilter="";
    this.pageNumber = 1;
    this.pageSize = 10;
    this.orderBy = 'briefingId ASC';    
    this.activedRoute.params.subscribe((params: Params) => {

      if (params['id']) {
        if (params['id'] != null) {
          this.briefingId = params['id'];
          this.getUserList();
        }
      }
      else {
        this.briefingId = 0;
      }
    });
  }

  keywordFilters($event) {
    this.keywordFilter = $event.target.value;
    if ($event.target.value != "" && $event.target.value != null) {
      this.keywordFilter = $event.target.value;
    }
    else { this.keywordFilter = ""; }

    this.getUserList();
  }

  getUserList() {

    this.isloading = true;
    if (this.keywordFilter == "null" || this.keywordFilter == "")
    { this.keywordFilter = "null";}
    this.trfaAlertServices.GetBriefingAlertsByIds(this.tokenKey,this.briefingId,this.pageNumber,this.pageSize,this.keywordFilter,this.userId,this.orderBy).subscribe(data => {
      if (data['status'] == 'Success') {
        this.isloading = false;
        this.BriefingModel1 = data['briefingAlert'];        
        if (this.BriefingModel1 != null) {
          if (this.BriefingModel1.length > 0) {
            this.totalRecordCount1 = +this.BriefingModel1[0].totalRowCount;
          }
          else {
            this.totalRecordCount1 = 0;
          }
        }
        this.title = this.BriefingModel1[0].title;
      }
      else {
        this.showMessage(data['status'], 'Error', 'error');
      }

    },
      error => {
        this.showMessage(error, 'Error', 'error');
      }
    );
  }

  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
  }

  redirectToEditView(briefingId:any,userId:any) {
    this.router.navigate(['/admin/briefingServices/briefing-Alerts/manage/' + briefingId + '/' + userId]);
  }
  
  pageChanged($event: any) {
    this.pageNumber = parseInt($event.page);
    this.getUserList();
  }

  sort(sortBy: any) {
    if (!this.isAscending) {
      this.isAscending = true;
      this.orderBy = sortBy + ' DESC';
      this.setDescCSS(sortBy);
    }
    else {
      this.isAscending = false;
      this.orderBy = sortBy;

      this.setAscCSS(sortBy);
    }
    this.getUserList();
  }

  setDescCSS(sortBy) {
    if (sortBy === "email") {
      this.upDownEmailCSS = 'fa fa-arrow-down';
      this.upDownNameCSS = '';
    }
    else if (sortBy === "name") {
      this.upDownEmailCSS = '';
      this.upDownNameCSS = 'fa fa-arrow-down';
    }
  }

  setAscCSS(sortBy) {
    if (sortBy === "email") {
      this.upDownEmailCSS = 'fa fa-arrow-up';
      this.upDownNameCSS = '';
    }
    else if (sortBy === "name") {
      this.upDownEmailCSS = '';
      this.upDownNameCSS = 'fa fa-arrow-up';
    }
  }

}
